const Resources = ((window) => {
  class Resources {
    constructor() {
      this._isGoogleMapsInitialized = false;
      this._googleMapsCallbacks = [];
    }

    initGoogleMaps() {
      this._isGoogleMapsInitialized = true;
      this._googleMapsCallbacks.forEach((callback) => {
        callback();
      });
    }

    waitForGoogleMaps(callback) {
      if (this._isGoogleMapsInitialized) {
        callback();
      } else {
        this._googleMapsCallbacks.push(callback);
      }
    }
  }

  const resources = new Resources();

  window.ION_initGoogleMaps = () => {
    resources.initGoogleMaps();
  };

  return resources;
})(window);

export default Resources;
